import Buttons from "views/Components/Buttons.jsx";
import Calendar from "views/Calendar/Calendar.jsx";
import Charts from "views/Charts/Charts.jsx";
import Dashboard from "views/Dashboard/Dashboard.jsx";
import ErrorPage from "views/Pages/ErrorPage.jsx";
import ExtendedForms from "views/Forms/ExtendedForms.jsx";
import ExtendedTables from "views/Tables/ExtendedTables.jsx";
import FullScreenMap from "views/Maps/FullScreenMap.jsx";
import GoogleMaps from "views/Maps/GoogleMaps.jsx";
import GridSystem from "views/Components/GridSystem.jsx";
import Icons from "views/Components/Icons.jsx";
import LockScreenPage from "views/Pages/LockScreenPage.jsx";
import LoginPage from "views/Pages/LoginPage.jsx";
import Notifications from "views/Components/Notifications.jsx";
import Panels from "views/Components/Panels.jsx";
import PricingPage from "views/Pages/PricingPage.jsx";
import RTLSupport from "views/Pages/RTLSupport.jsx";
import ReactTables from "views/Tables/ReactTables.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import RegularForms from "views/Forms/RegularForms.jsx";
import RegularTables from "views/Tables/RegularTables.jsx";
import SweetAlert from "views/Components/SweetAlert.jsx";
import TimelinePage from "views/Pages/Timeline.jsx";
import Typography from "views/Components/Typography.jsx";
import UserProfile from "views/Pages/UserProfile.jsx";
import ValidationForms from "views/Forms/ValidationForms.jsx";
import VectorMap from "views/Maps/VectorMap.jsx";
import Widgets from "views/Widgets/Widgets.jsx";
import Wizard from "views/Forms/Wizard.jsx";
import JobCardManagemnt from "views/Pages/jobs/ViewJobCards.jsx";
import CreateJobCard from "views/Pages/jobs/CreateJobCard.jsx"
import JobCardView from "views/Pages/jobs/JobCardView.jsx";
import Workspace from "views/Pages/Workspace.jsx";
import RegisterProject from './views/Pages/projects/RegisterProject.jsx'
import viewProjects from "./views/Pages/projects/viewProjects";
import ViewCompanies from "./views/Pages/company/ViewCompanies.jsx";
import RegisterCompany from "./views/Pages/company/RegisterCompany.jsx";
import RegisterUser from "./views/Pages/users/RegisterUser.jsx";
import ViewUsers from "./views/Pages/users/ViewUsers.jsx";


// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DateRange from "@material-ui/icons/DateRange";
import GridOn from "@material-ui/icons/GridOn";
import Image from "@material-ui/icons/Image";
import Place from "@material-ui/icons/Place";
import Timeline from "@material-ui/icons/Timeline";
import WidgetsIcon from "@material-ui/icons/Widgets";
import Assignment from "@material-ui/icons/Assignment";
import People from "@material-ui/icons/People";
import Work from "@material-ui/icons/Work";
import Business from "@material-ui/icons/Business";
import Home from "@material-ui/icons/Home";
import QualityControlWorkspace from "./views/Pages/QualityControlWorkspace.jsx";
import WorkspaceExternal from "./views/Pages/WorkspaceExternal.jsx";
import CreateMeter from "./views/Pages/stockController/CreateMeter.jsx";
import ViewMeters from "./views/Pages/stockController/ViewMeters.jsx";



var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin",
    showToExternal: true,
    hideToInternal: false,
    disallowedRoles : [ 'Contractor', 'Inspector', 'Technician']
  },
  {
    path: "/workspace",
    name: "My Workspace",
    icon: Home,
    component: Workspace,
    layout: "/admin",
    showToExternal: false,
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
  },
  {
    path: "/workspaceExternal",
    name: "My Workspace External",
    icon: Home,
    component: WorkspaceExternal,
    layout: "/admin",
    showToExternal: true,
    hideToInternal: true,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician'],
  },

  {
    path: "/quality-control-workspace",
    name: "Quality Control Workspace",
    icon: WidgetsIcon,
    component: QualityControlWorkspace,
    layout: "/admin",
    showToExternal: false,
    hideToInternal: false,
    disallowedRoles : ['Management', 'StockController', 'Contractor', 'Inspector', 'Technician'],
  },

  {
    collapse: true,
    name: "Manage Job Cards",
    icon: Assignment,
    state: "jobCardsCollapse",
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician'],

    views: [ 
      {
        path: "/create/jobcard",
        name: "Create Job Cards",
        mini: "CJ",
        component: CreateJobCard,
        layout: "/admin",
        showToExternal: false,
        hideToInternal: false,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      },
      {
        path: "/jobcards",
        name: "View Job Cards",
        mini: "VJ",
        component: JobCardManagemnt,
        layout: "/admin",
        showToExternal: true,
        hideToInternal: false,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      },
    ]
  }, 

  {
    collapse: true,
    name: "Manage Stock",
    icon: Assignment,
    state: "stockCollapse",
    hideToInternal: false,
    disallowedRoles : ['Auditor'],
    views: [ 
      {
        path: "/createmeter",
        name: "Create Meter",
        mini: "CM",
        component: CreateMeter,
        layout: "/admin",
        showToExternal: true,
        hideToInternal: false,
        disallowedRoles : [ 'Management', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      },
      {
        path: "/meters",
        name: "View Meters",
        mini: "VM",
        component: ViewMeters,
        layout: "/admin",
        showToExternal: true,
        hideToInternal: false,
        disallowedRoles : [ 'Management', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      },
    ]
  },
  {
    path: "/job/view/:jobNumber",
    component: JobCardView,
    innerPage: true,
    layout: "/admin",
    showToExternal: true,
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Inspector', 'Technician']
  },
  {
    collapse: true,
    name: "Manage Users",
    icon: People,
    state: "usersCollapse",
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician'],

    views: [ 
      {
        path: "/register",
        name: "Register User",
        mini: "RU",
        component: RegisterUser,
        layout: "/admin",
        showToExternal: false,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      },
      {
        path: "/users",
        name: "View Users",
        mini: "VU",
        component: ViewUsers,
        layout: "/admin",
        showToExternal: true,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      }
    ]
  },
  {
    collapse: true,
    name: "Manage Projects",
    icon: Work,
    state: "ProjectsCollapse",
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician'],

    views: [ 
      {
        path: "/project",
        name: "Register Project",
        mini: "RP",
        component: RegisterProject,
        layout: "/admin",
        showToExternal: false,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      },
      {
        path: "/Projects",
        name: "View Projects",
        mini: "VP",
        component: viewProjects,
        layout: "/admin",
        showToExternal: false,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      }
    ]
  },

  {
    collapse: true,
    name: "Manage Contractors",
    icon: Business,
    state: "CompanyCollapse",
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician'],

    views: [ 
      {
        path: "/company",
        name: "Register Contractor",
        mini: "RC",
        component: RegisterCompany,
        layout: "/admin",
        showToExternal: false,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      },
      {
        path: "/companies",
        name: "View Contractors",
        mini: "VC",
        component: ViewCompanies,
        layout: "/admin",
        showToExternal: false,
        disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
      }
    ]
  },

  {
    path: "/calendar",
    name: "Calendar",
    rtlName: "التقويم",
    icon: DateRange,
    component: Calendar,
    layout: "/admin",
    showToExternal: false,
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
  },
  {
    path: "/login-page",
    name: "Login Page",
    rtlName: "هعذاتسجيل الدخول",
    mini: "L",
    rtlMini: "هعذا",
    component: LoginPage,
    layout: "/auth",
    showToExternal: false,
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
  },
  {
    path: "/lock-screen-page",
    name: "Lock Screen Page",
    component: LockScreenPage,
    layout: "/auth",
    showToExternal: false,
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
  },
  {
    path: "/lock-screen-page",
    name: "Lock Screen Page",
    component: LockScreenPage,
    layout: "/auth",
    showToExternal: false,
    hideToInternal: false,
    disallowedRoles : ['StockController', 'Contractor', 'Auditor', 'Inspector', 'Technician']
  },
 
];
export default dashRoutes;
